function success(message) {
  show('success', message);
}

function error(message) {
  show('error', message);
}

function info(message) {
  show('info', message);
}

function show(type, message) {
  const body = document.body;

  // Ищем контейнер для toast'ов
  let toastContainer = document.getElementById('toast-container') || document.querySelector('.toast-container');
  
  if (!toastContainer) {
    toastContainer = document.createElement('div');
    toastContainer.id = 'toast-container';
    toastContainer.style.cssText = 'position: fixed; top: 1rem; right: 1rem; z-index: 9999; display: flex; flex-direction: column; gap: 0.5rem; pointer-events: none;';
    body.append(toastContainer);
  } else {
    // Добавляем стили к существующему контейнеру
    toastContainer.style.cssText = 'position: fixed; top: 1rem; right: 1rem; z-index: 9999; display: flex; flex-direction: column; gap: 0.5rem; pointer-events: none;';
  }

  const toast = document.createElement('div');
  
  function remove() {
    toast.classList.add('opacity-0', 'translate-x-full');
    setTimeout(() => {
      toast.remove();
      // Удаляем контейнер если больше нет toast'ов
      if (body && !document.querySelector('.toast-container')?.querySelector('.toast')) {
        document.querySelector('.toast-container')?.remove();
      }
    }, 300);
  }

  // Базовые стили
  toast.classList.add('toast', 'flex', 'items-center', 'p-4', 'mb-2', 'text-sm', 'rounded-lg', 'shadow-lg', 'border-l-4', 'transition-all', 'duration-300', 'max-w-md');
  toast.style.pointerEvents = 'auto';
  
  // Стили в зависимости от типа
  if (type === 'success') {
    toast.classList.add('text-green-800', 'bg-green-50', 'border-green-500');
    toast.innerHTML = `
      <div class="flex items-center gap-3 w-full">
        <div class="flex-shrink-0">
          <i class="fas fa-check-circle text-green-500 text-xl"></i>
        </div>
        <div class="flex-1 font-exo">${message}</div>
        <button class="flex-shrink-0 ml-auto text-green-500 hover:text-green-700 transition-colors close-toast">
          <i class="fas fa-times"></i>
        </button>
      </div>
    `;
  } else if (type === 'error') {
    toast.classList.add('text-red-800', 'bg-red-50', 'border-red-500');
    toast.innerHTML = `
      <div class="flex items-center gap-3 w-full">
        <div class="flex-shrink-0">
          <i class="fas fa-exclamation-circle text-red-500 text-xl"></i>
        </div>
        <div class="flex-1 font-exo">${message}</div>
        <button class="flex-shrink-0 ml-auto text-red-500 hover:text-red-700 transition-colors close-toast">
          <i class="fas fa-times"></i>
        </button>
      </div>
    `;
  } else {
    toast.classList.add('text-blue-800', 'bg-blue-50', 'border-blue-500');
    toast.innerHTML = `
      <div class="flex items-center gap-3 w-full">
        <div class="flex-shrink-0">
          <i class="fas fa-info-circle text-blue-500 text-xl"></i>
        </div>
        <div class="flex-1 font-exo">${message}</div>
        <button class="flex-shrink-0 ml-auto text-blue-500 hover:text-blue-700 transition-colors close-toast">
          <i class="fas fa-times"></i>
        </button>
      </div>
    `;
  }
  
  // Обработчик закрытия
  toast.querySelector('.close-toast')?.addEventListener('click', remove);

  toastContainer.append(toast);

  // Анимация появления
  setTimeout(() => toast.classList.add('toast-visible'), 10);
  
  // Автоматическое скрытие через 5 секунд
  setTimeout(remove, 5000);
}

const toast = { success, error, info };

export default toast;
